
/* ============================== src/api/queries/chat-reads.js ============================== */
// src/api/queries/chat-reads.js
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../client";

export const CHAT_READS_KEY = ["chat-reads"];

export function useChatReadsQuery(options = {}) {
  return useQuery({
    queryKey: CHAT_READS_KEY,
    queryFn: () => api.get("/chat-reads"),
    staleTime: 30 * 1000,
    ...options,
  });
}

export function useMarkChatReadMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => api.post("/chat-reads", body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["unread-counts"] });
      qc.invalidateQueries({ queryKey: CHAT_READS_KEY }); // добавили, чтобы useChatReadLookup обновлялся
    },
  });
}
